
<div class="approval-container">
  <div class="section-title">
    <span class="air-heading">TLR Approvals</span>
  </div>
  <div class="details-link">
    <span label="GO TO DETAILS" class="link-underline" style="text-decoration: underline ;font-weight : bold; font-size: 14px;" (click)="goToDetails()"> GO TO DETAILS</span>
  </div>

  <!-- Operations Table -->
  <div class="panel-header operations">
    Operations
  </div>
  <div class="content-table">
    <div class="table-row bgOdd">
      <div class="table-cell label">Date Entered Into System</div>
      <div class="table-cell value">{{operationData.dateEntered}}</div>
      <div class="table-cell label">Associated Plant - Shutdown</div>
      <div class="table-cell value">{{operationData.associatedPlant}}</div>
    </div>
    <div class="table-row bgEven">
      <div class="table-cell label">Operator User ID</div>
      <div class="table-cell value">{{operationData.operatorCAI}}</div>
      <div class="table-cell label">Shutdown Description</div>
      <div class="table-cell value">{{operationData.shutdownDescription}}</div>
    </div>
    <div class="table-row bgOdd">
      <div class="table-cell label">TLR Status</div>
      <div class="table-cell value" [ngClass]="{
        'status-installed': operationData.tlrStatus === 'Installed',
        'status-removed': operationData.tlrStatus === 'Removed',
        'status-pending': operationData.tlrStatus === 'Pending'
      }">{{operationData.tlrStatus}}</div>
      <div class="table-cell label">Rule 1173</div>
      <div class="table-cell value">{{operationData.rule1173}}</div>
    </div>
    <div class="table-row">
      <div class="table-cell label">Repair Type</div>
      <div class="table-cell value">{{operationData.repairType}}</div>
      <div class="table-cell label">Vapor/Liquid</div>
      <div class="table-cell value">{{operationData.materialState}}</div>
    </div>
    <div class="table-row bgOdd">
      <div class="table-cell label">Tag Number</div>
      <div class="table-cell value">{{operationData.tagNumber}}</div>
      <div class="table-cell label">Leaking From</div>
      <div class="table-cell value">{{operationData.leakingFrom}}</div>
    </div>
    <div class="table-row">
      <div class="table-cell label">Division</div>
      <div class="table-cell value">{{operationData.division}}</div>
      <div class="table-cell label">Other Leak Type specified here</div>
      <div class="table-cell value">{{operationData.leakingFromOther}}</div>
    </div>
    <div class="table-row bgOdd">
      <div class="table-cell label">Section</div>
      <div class="table-cell value">{{operationData.section}}</div>
      <div class="table-cell label">Operating PSI</div>
      <div class="table-cell value">{{operationData.operatingPSI}}</div>
    </div>
    <div class="table-row">
      <div class="table-cell label">Plant</div>
      <div class="table-cell value">{{operationData.plant}}</div>
      <div class="table-cell label">Operating Temperature</div>
      <div class="table-cell value">{{operationData.operatingTemp}}</div>
    </div>
    <div class="table-row bgOdd">
      <div class="table-cell label">Service</div>
      <div class="table-cell value">
        <div class="service-item">{{operationData.services}}</div>
      </div>
      <div class="table-cell label">Other Service</div>
      <div class="table-cell value">{{operationData.serviceOther}}</div>
    </div>
    <div class="table-row">
      <div class="table-cell label">Permanent Repair Completed</div>
      <div class="table-cell value">{{operationData.permRepairCompleted}}</div>
      <div class="table-cell label">Technical Justification</div>
      <div class="table-cell value">{{operationData.techJustification}}</div>
    </div>
    <div class="table-row bgOdd">
      <div class="table-cell label">Location / Comments</div>
      <div class="table-cell value full-row">{{operationData.comments}}</div>
    </div>
  </div>

  <!-- Inspections Table -->
  <div class="panel-header inspections">
    Inspections
  </div>
  <div class="content-table">
    <div class="table-row bgOdd">
      <div class="table-cell label">Date Modified</div>
      <div class="table-cell value">{{inspectionData.inspectionDate}}</div>
      <div class="table-cell label">OPPIS Line?</div>
      <div class="table-cell value">{{inspectionData.OPPIS}}</div>
    </div>
    <div class="table-row">
      <div class="table-cell label">Inspector User ID</div>
      <div class="table-cell value">{{inspectionData.inspectorCAI}}</div>
      
      <div class="table-cell label">EWO Required</div>
      <div class="table-cell value">{{inspectionData.EWORequired}}</div>
    </div>
    <div class="table-row bgOdd">
       <div class="table-cell label">Inspection ISO No.</div>
      <div class="table-cell value full-row">{{inspectionData.InspectionISONo}}</div>
      </div>
    <div class="table-row">
      <div class="table-cell label">Service Class</div>
      <div class="table-cell value full-row">{{inspectionData.serviceClass}}</div>
    </div>
    <div class="table-row bgOdd">
      <div class="table-cell label">Inspector Comments</div>
      <div class="table-cell value full-row">{{inspectionData.comments}}</div>
    </div>
  </div>

  <!-- OA Table -->
  <div class="panel-header oa">
    OA
  </div>
  <div class="content-table">
    <div class="table-row bgOdd">
      <div class="table-cell label">Permanent Repair Date</div>
      <div class="table-cell value">{{oaData.permanentRepairDate}}</div>
      <div class="table-cell label">NAMO Date</div>
      <div class="table-cell value">{{oaData.namoDate}}</div>
    </div>
  </div>

  <hr />
  <!-- Warning Messages -->
  <div class="warning-messages">
    <div class="warning-critical">**It is very Important to enter the correct User ID's. Please double check your
      entries BEFORE clicking Save Changes.**</div>
    <div class="warning-notice">After all Approvals, the TLR application will send an Approval Complete auto email to
      the OMC, OA, Inspector, and Engineer for the Plant.</div>
    <div class="warning-help">Light Green box can't edit. To Edit Record, delete the record, enter new User ID and Save
      Changes.</div>
    <!-- <div *ngIf="emailMessage" class="email-message">{{emailMessage}}</div> -->
  </div>

  <!-- Tabs Section -->
  <np-tabbed>
    <ul class="tabs">
      <li role="tab" [attr.aria-selected]="activeTabIndex === 0 ? 'true' : 'false'" (click)="activeTabIndex = 0">
        Approvals</li>
      <li role="tab" [attr.aria-selected]="activeTabIndex === 1 ? 'true' : 'false'" (click)="activeTabIndex = 1">Repump
        Approvals</li>
    </ul>

    <div class="tab-content" role="tabpanel" [attr.aria-hidden]="activeTabIndex !== 0">     
       <!-- <span class="record-updated" *ngIf="recordUpdated">Updated record</span>
      <span class="record-updated" *ngIf="noRecordsTOSave">No Record(s) to 'SAVE'.</span>
        <span class="record-updated" *ngIf="emailSent">Email Sent.</span> -->
        <span class="record-updated" *ngIf="responseMessage">{{responseMessage}}</span>
      <div class="tab-title">Approvals</div>      <p-table [value]="approvalRecords" id="StyleTable" styleClass="p-datatable-gridlines"
        [tableStyle]="{'min-width': '50rem'}">
        <ng-template pTemplate="header">
          <tr>
            <th>Position</th>
            <th>Requirements</th>
            <th>Email ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Email Sent TimeStamp</th>
            <th>Approved By User ID</th>
            <th>Approved TimeStamp</th>
            <th>Status</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-record>
          <tr>
            <td class="position-column">{{record.position}}</td>
            <td class="requirements-column">
              <div *ngFor="let requirement of formatRequirements(record.requirements)" class="requirement-item">
                • {{requirement}}
              </div>
            </td>            <td>              <span class="p-input-icon-right" *ngIf="!showReOpenButton || record.positionCAI">
                <input pInputText type="text" class="cai-input" [(ngModel)]="record.positionCAI"
                  [style.background-color]="record.positionCAI && record.id !== '0' ? '#90EE90' : 'white'"
                  [readonly]="record.positionCAI && record.id !== '0'">
              </span>
              <div *ngIf="showValidationErrors && record.positionCAI && record.id === '0'" class="invalid-cai">Invalid User ID</div>
            </td>
            <td>{{record.name || ''}}</td>
            <td>{{record.email || ''}}</td>
            <td>{{record.emailSentDate}}</td>
            <td>{{record.approvedBy}}</td>
            <td>{{record.approvedDate}}</td>     
                   
            <td>
              <button *ngIf="shouldShowApproveButton(record)" pButton class="primary-btn h-30" 
                      label="Approve" (click)="approveRecord(record.id)"></button>
              <button *ngIf="shouldShowPendingButton(record)" pButton class="cancel-btn  h-30" label="Pending"></button>
              <button *ngIf="shouldShowApprovedButton(record)" pButton class="cancel-btn  h-30" label="Approved"></button>
            </td>            <td>
              <button *ngIf="shouldShowDeleteButton(record)" pButton class="cancel-btn h-30" label="Delete" (click)="deleteRecord(record.id)"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>      <div class="button-row">
        <p-button *ngIf="showReOpenButton" styleClass="p-button-secondary" 
          label="Re-Open Approvals" (click)="reOpenApprovals()"></p-button>
        <p-button *ngIf="showSaveButton" styleClass="p-button-primary" 
          label="Save Changes" (onClick)="saveApprovalChanges()"></p-button>        <p-button *ngIf="showReSendButton" styleClass="p-button-info" 
          label="Re-Send Approval Email(s)" (click)="reSendApprovalEmails()"></p-button>
      </div>
    </div>

    <!-- <div class="tab-content" role="tabpanel" [attr.aria-hidden]="activeTabIndex !== 1">
      <div class="tab-title">Repump Approvals</div>
     
    </div> -->
 <div class="tab-content" role="tabpanel" [attr.aria-hidden]="activeTabIndex !== 1">
  <span class="record-updated" *ngIf="repumpMessage">{{repumpMessage}}</span>

      <div class="tab-title">Repump Approvals</div>
      <div *ngIf="repumpApprovalRecords.length > 0" class="repump-total">Total Repumps: {{totalRepumpCount}}</div>
      
      <!-- Repump History Table -->
      <div *ngIf="repumpHistoryData && repumpHistoryData.length > 0" class="repu mp-history-section">
        <p-table [value]="repumpHistoryData" styleClass="p-datatable-gridlines" id="StyleTable"
          [tableStyle]="{'min-width': '50rem'}">
          <ng-template pTemplate="header">
            <tr >
              <th [width]="100">Tag #</th>
              <th [width]="200">Repump Date</th>
              <th [width]="250">User ID</th>
              <th>Repump Comments</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-record>
            <tr >
              <td>{{record.tagNumber}}</td>
              <td>{{record.repumpDate | date:'MM-dd-yyyy hh:mm:ss a'}}</td>
              <td>{{record.repumpCAI}}</td>
              <td>{{record.repumpComments}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      
      <!-- Repump Approvals Table -->
      <p-table [value]="repumpApprovalRecords" id="StyleTable" styleClass="p-datatable-gridlines"
        [tableStyle]="{'min-width': '50rem'}">
        <ng-template pTemplate="header">
          <tr>
            <th>Position</th>
            <th>Requirements</th>
            <th>Email ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Email Sent TimeStamp</th>
            <th>Approved By User ID</th>
            <th>Approved TimeStamp</th>
            <th>Status</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-record let-i="rowIndex">
          <tr>
            <td class="position-column">{{record.positionPump}}</td>
            <td class="requirements-column">
               <div *ngFor="let requirement of formatRequirements(record.requirements)" class="requirement-item">
                • {{requirement}}
              </div>
            </td>
            <td style="display: none;"></td>            <td>
              <span class="p-input-icon-right" *ngIf="!showRepumpReOpenButton || record.positionPumpCAI">
                <input pInputText type="text" class="cai-input" [(ngModel)]="record.positionPumpCAI"
                  [style.background-color]="record.positionPumpCAI && record.id !== '0' ? '#90EE90' : 'white'"
                  [readonly]="record.positionPumpCAI && record.id !== '0'">
              </span>
              <div *ngIf="showRepumpValidationErrors && record.positionPumpCAI && record.id === '0'" class="invalid-cai">Invalid User ID</div>
            </td>
            <td>{{record.positionPumpName || ''}}</td>
            <td>{{record.positionPumpEmail || ''}}</td>
            <td>{{record.emailPumpSentDate}}</td>
            <td>{{record.approvedPumpBy}}</td>
            <td>{{record.approvedPumpDate}}</td>
            <td>
              <button *ngIf="shouldShowRepumpApprovedButton(record)" pButton class="cancel-btn ml-10 h-30"
                label="Approved"></button>
              <button *ngIf="shouldShowRepumpApproveButton(record)" pButton
                (click)="approveRepumpRecord(record)"
                class="primary-btn h-30" label="Approve"></button>
              <button *ngIf="shouldShowRepumpPendingButton(record)" pButton class="cancel-btn ml-10 h-30"
                label="Pending"></button>
            </td>
            <td>
              <button *ngIf="shouldShowRepumpDeleteButton(record)" pButton
                (click)="deleteRepumpRecord(record)"
                class="cancel-btn ml-10 h-30" label="Delete"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div class="button-row">
        <p-button *ngIf="showRepumpReOpenButton" styleClass="p-button-secondary" 
         (click)="rePumpReOpenApprovals()" label="Re-Open Re-Pump Approvals"></p-button>
        <p-button *ngIf="showRepumpSaveButton" styleClass="p-button-primary"
          (onClick)="saveRepumpApprovalChanges()"
          label="Re-Pump Save Changes"></p-button>
        <p-button *ngIf="showRepumpReSendButton" styleClass="p-button-info"
          (click)="reSendRepumpApprovalEmails()"
          label="Re-Send Approval Email(s)"></p-button>
      </div>
    </div>

  </np-tabbed>
</div>